import Authapi from "../components/Services/Authapi";

export const CALENDAR_COLORS_STORAGE_KEY = "hrmsCalendarColorSettings";
export const CALENDAR_COLORS_STORAGE_EVENT = "hrms-calendar-colors-updated";

export const DEFAULT_CALENDAR_COLORS = {
  Title: "#6d28d9",
  Meeting: "#7e22ce",
  Event: "#1d4ed8",
  Holiday: "#c21845",
  "Leave - Approved": "#16a34a",
  "Leave - Pending": "#e5e562",
  "Leave - Cancelled": "#eab308",
  "Leave - Declined": "#e4aaaa",
  "Leave - Unapproved": "#e34d4d",
  Birthday: "#be185d",
};

export const getCalendarColorSettings = () => {
  try {
    const stored = window.localStorage.getItem(CALENDAR_COLORS_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return { ...DEFAULT_CALENDAR_COLORS, ...parsed };
    }
  } catch (e) {
    console.error("Error reading calendar color settings:", e);
  }
  return { ...DEFAULT_CALENDAR_COLORS };
};

export const saveCalendarColorSettings = (colors) => {
  try {
    const nextColors = { ...DEFAULT_CALENDAR_COLORS, ...colors };
    window.localStorage.setItem(CALENDAR_COLORS_STORAGE_KEY, JSON.stringify(nextColors));
    window.dispatchEvent(new CustomEvent(CALENDAR_COLORS_STORAGE_EVENT, { detail: nextColors }));

    Authapi.getStatusColors().then((res) => {
      const currentData = res && res.data && typeof res.data === "object" ? res.data : {};
      Authapi.updateStatusColors({
        ...currentData,
        calendar_colors: nextColors,
      });
    });

    return nextColors;
  } catch (e) {
    console.error("Error saving calendar color settings:", e);
  }
  return colors;
};

export const fetchAndSyncCalendarColors = async () => {
  try {
    const res = await Authapi.getStatusColors();
    if (res && res.status && res.data && res.data.calendar_colors) {
      const serverColors = res.data.calendar_colors;
      const merged = { ...DEFAULT_CALENDAR_COLORS, ...serverColors };
      window.localStorage.setItem(CALENDAR_COLORS_STORAGE_KEY, JSON.stringify(merged));
      window.dispatchEvent(new CustomEvent(CALENDAR_COLORS_STORAGE_EVENT, { detail: merged }));
      return merged;
    }
  } catch (e) {
    console.error("Error syncing calendar colors from server:", e);
  }
  return getCalendarColorSettings();
};
